import { render, staticRenderFns } from "./Meaning.vue?vue&type=template&id=0d00ef66&scoped=true&"
import script from "./Meaning.vue?vue&type=script&lang=js&"
export * from "./Meaning.vue?vue&type=script&lang=js&"
import style0 from "./Meaning.vue?vue&type=style&index=0&id=0d00ef66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d00ef66",
  null
  
)

export default component.exports